import { motion } from "framer-motion";
import { FileJson, FileCode2, Box, Braces, FileText, CheckCircle2 } from "lucide-react";

const FORMATS = [
  {
    icon: FileJson,
    name: "OpenAPI 3.x",
    desc: "JSON or YAML",
    color: "text-blue-500",
    bg: "bg-blue-50 dark:bg-blue-950/40",
    border: "border-blue-100 dark:border-blue-900",
  },
  {
    icon: FileCode2,
    name: "Swagger 2.0",
    desc: "Legacy REST specs",
    color: "text-green-500",
    bg: "bg-green-50 dark:bg-green-950/40",
    border: "border-green-100 dark:border-green-900",
  },
  {
    icon: Box,
    name: "Postman",
    desc: "Collections v2.1",
    color: "text-orange-500",
    bg: "bg-orange-50 dark:bg-orange-950/40",
    border: "border-orange-100 dark:border-orange-900",
  },
  {
    icon: Braces,
    name: "GraphQL",
    desc: "SDL schemas",
    color: "text-pink-500",
    bg: "bg-pink-50 dark:bg-pink-950/40",
    border: "border-pink-100 dark:border-pink-900",
  },
  {
    icon: FileText,
    name: "Plain Text",
    desc: "API descriptions",
    color: "text-violet-500",
    bg: "bg-violet-50 dark:bg-violet-950/40",
    border: "border-violet-100 dark:border-violet-900",
  },
];

const FormatsSection = () => (
  <section className="py-10 px-6 border-y border-border/40 bg-muted/20">
    <div className="container max-w-5xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center gap-6"
      >
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-widest">
          Paste any of these formats — we handle the rest
        </p>

        <div className="flex flex-wrap justify-center gap-3">
          {FORMATS.map((f, i) => (
            <motion.div
              key={f.name}
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.07 }}
              className={`flex items-center gap-2.5 px-4 py-2.5 rounded-xl border ${f.bg} ${f.border} shadow-sm`}
            >
              <f.icon className={`w-4 h-4 shrink-0 ${f.color}`} />
              <div className="leading-none">
                <p className="text-xs font-semibold text-foreground">{f.name}</p>
                <p className="text-[10px] text-muted-foreground mt-0.5">{f.desc}</p>
              </div>
              <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 shrink-0 ml-0.5" />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);

export default FormatsSection;
